export default "__VITE_ASSET__Mhi_JYxK__"